export const customerUrls = {
    dashboard: {
        general: '/customer/dashboard',
    }, orders: {
        list: "/customer/orders",
        item: id => id ? `/customer/orders/${id}` : '/customer/orders'
    }, comments: {
        list: "/customer/comments",
        item: id => id ? `/customer/comments/${id}` : '/customer/comments',
    }, addresses: {
        list: "/customer/address",
        item: id => id ? `/customer/address/${id}` : '/customer/address',
    }, favorite: {
        list: "/customer/favorite",
        item: id => id ? `/customer/favorite/${id}` : "/customer/favorite"
    }, myDoors: {
        list: "/customer/my-doors",
        item: id => id ? `/customer/my-doors/${id}` : "/customer/my-doors"
    }, profile: {
        accountData: "/customer/profile",
        mobile: "/customer/profile/mobile",
        otp: "/customer/profile/otp",
    },
}

export default customerUrls;


